import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

const m_institution = 
{
  id: 1,
  is_interview_unification: true
}

describe('DisplaySettings', () => {
  describe('Index', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          m_template_owners: [
            {delf: 0, id: 1, m_template_description: "説明文1", m_template_id: 1, m_template_name: "男性", sort_no: 1, is_patient_view: false}, 
            {delf: 1, id: 2, m_template_description: "説明文2", m_template_id: 2, m_template_name: "女性", sort_no: 2, is_patient_view: true},
            {delf: 1, id: 3, m_template_description: "説明文3", m_template_id: 3, m_template_name: "小児", sort_no: 3, is_patient_view: false, template_kbn: 30},
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index m_institution={m_institution}/>);

      await act(() => promise);


      expect(screen.getByText('アンケート表示設定')).toBeInTheDocument();

      expect(screen.queryByText('▲')).toBeNull();
      expect(screen.queryByText('▼')).toBeNull();

      // 1レコード目(表示/非表示)
      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('説明文1')).toBeInTheDocument();

      // 2レコード目(非表示/表示)
      expect(screen.getByText('女性')).toBeInTheDocument();
      expect(screen.getByText('説明文2')).toBeInTheDocument();

      // 3レコード目(非表示/非活性)
      expect(screen.getByText('小児')).toBeInTheDocument();
      expect(screen.getByText('説明文3')).toBeInTheDocument();
    });  
  }); 
});

